import { render, staticRenderFns } from "./vivaCandiList.vue?vue&type=template&id=5439babe&"
import script from "./vivaCandiList.vue?vue&type=script&lang=js&"
export * from "./vivaCandiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports